import React from 'react';
import { Row, Col, Container } from 'reactstrap';
import PropTypes from 'prop-types';
import qs from 'qs';
import { connect } from 'react-redux';
import { useRouter } from 'next/router';
import _ from 'lodash';
import Image from 'flaivy-react/components/Image';
import { getQuerySpecification } from 'flaivy-react/utils/query-specification-functions';
import Articles from '../../../components/article/Articles';
import getAxiosInstance from '../../../config/api';
import ShowMore from '../../../components/ShowMore';
import { SuggestNewSupplierModalForm } from 'components/action-forms/supplier/SuggestNewSupplierModalForm';
import loginAwareComponent from 'components/LoginAwareComponent';
import Error from 'next/error';

const getBrand = async (req, name) => {
  const query = qs.stringify({ query: { name } });
  console.log('getBrand with name', query);

  const axiosInstance = await getAxiosInstance(req);
  const response = await axiosInstance.get(`/public/brands?${query}`);
  console.log('getBrand with name response', response.data);

  const brandId = _.get(response.data, 'rows[0].id');
  const response2 = await axiosInstance.get(`/public/brands/${brandId}`);
  return response2.data;
};

function Brand({
  brand,
  querySpecification,
  authentication,
  shopConfig,
  notFound,
  ...articleProps
}) {
  const router = useRouter();

  if (notFound) {
    return <Error statusCode={404} />;
  }
  const { name, image, description } = brand;
  const { email, customerSubUnit, supplierCustomer } =
    authentication.sessionUser;
  const customer = supplierCustomer || customerSubUnit;

  const querySpec = getQuerySpecification(router.query, querySpecification);
  querySpec.brand = brand.id;
  return (
    <>
      <Container className="mt-2" id="content">
        <Row className="mt-5 justify-content-between">
          <Col className="pt-5 text-center" xs={12} lg={4}>
            <Image resX={400} resY={400} alt={name} src={image} />
          </Col>
          <Col xs={12} lg={7}>
            <Row className="align-items-center">
              <Col xs={6}>
                <h1 className="mt-3">{name}</h1>
              </Col>
              {authentication.isAuthenticated && (
                <Col xs={6}>
                  <SuggestNewSupplierModalForm
                    entity={{}}
                    buttonText={`Önska artikel`}
                    immutableFields={{
                      brandName: name,
                      yourEmail: email,
                      yourCompany: customer.name,
                    }}
                  />
                </Col>
              )}
            </Row>
            <Row>
              <Col xs={12}>
                <ShowMore maxHeight="300px">
                  {description && (
                    <div
                      suppressHydrationWarning
                      className="mt-3"
                      // eslint-disable-next-line react/no-danger
                      dangerouslySetInnerHTML={{ __html: description }}
                    />
                  )}
                </ShowMore>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row className="g-0">
          <Col xs={12}>
            <Articles
              // eslint-disable-next-line react/jsx-props-no-spreading
              {...{
                ...articleProps,
                shopConfig,
                hideShortcuts: true,
                hideSearchInput: true,
                querySpecification: querySpec,
                pageConfig: { layout: { hasFilterPanel: true } },
              }}
            />
          </Col>
        </Row>
      </Container>
    </>
  );
}

Brand.getInitialProps = async ({ req, res, query, authentication }) => {
  let brand;
  const brandId = _.get(query, 'id');
  console.log('Brand getInitialProps', query);

  try {
    if (query.id.length === 36) {
      const axiosInstance = await getAxiosInstance(req);
      const response = await axiosInstance.get(`/public/brands/${brandId}`);
      brand = response.data;
    } else {
      brand = await getBrand(req, brandId);
    }
  } catch (error) {
    if (res) {
      console.log('Brand not found');

      res.statusCode = 404;
    }
    return { notFound: true };
  }
  const querySpecification = {
    ...qs.parse(query.querySpecification),
    brand: brand.id,
  };

  const pageSpecificProps = await Articles.getInitialProps({
    req,
    querySpecification,
    pageConfig: { layout: { hasFilterPanel: true } },
  });

  return {
    ...pageSpecificProps,
    querySpecification,
    brand,
    authentication,
    query,
  };
};

Brand.propTypes = {
  brand: PropTypes.object.isRequired,
  shopConfig: PropTypes.object.isRequired,
  querySpecification: PropTypes.object.isRequired,
};

Brand.defaultProps = {};

const mapStateToProps = (shopConfig) => ({
  shopConfig,
});

export default loginAwareComponent(connect(mapStateToProps)(Brand));
